module.exports = __webpack_public_path__ + "assets/img/5f70-ky.svg";